export default "__VITE_ASSET__67a64668__"